import React from 'react';
import './AdminLayout.scss';
import { Layout, Menu, Breadcrumb, Avatar, Typography } from 'antd';
import {
    PieChartOutlined,
    FileOutlined,
    TeamOutlined,
    UserOutlined,
    LogoutOutlined,
    QuestionCircleOutlined,
    ReadOutlined,
    MenuOutlined,
    CloseOutlined
} from '@ant-design/icons';
import logo from '../../img/logo.png';
import { Link, useHistory } from "react-router-dom";
import { useState, useEffect } from 'react';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;
const { Title } = Typography;


const AdminLayout = ({ children, profile }) => {


    const [state, setState] = useState({
        collapsed: false,
        menuCollapsed: true
    });

    let history = useHistory();

    const onCollapse = collapsed => {
        console.log(collapsed);
        setState({ ...state, collapsed });
    };

    const toggleMenu = () => {
        setState({ ...state, menuCollapsed: !menuCollapsed })
    }

    const { collapsed, menuCollapsed } = state;

    useEffect(() => {
        setState({ ...state, menuCollapsed: true })
    }, [history.location]);
    return (

        <Layout style={{ minHeight: '100vh' }} className="admin-page">
            <Sider collapsible collapsed={collapsed} onCollapse={onCollapse} >
                {!collapsed && <div className="logo" > <img src={logo} alt="" /></div>}
                <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
                    <Menu.Item key="1" icon={<UserOutlined />}>
                        <Link to="/Users">Users</Link>
                    </Menu.Item>
                    <Menu.Item key="2" icon={<PieChartOutlined />}>
                        <Link to="/Dashboard">Dashboard</Link>
                    </Menu.Item>
                    <Menu.Item key="3" icon={<ReadOutlined />}>
                        <Link to="/Chapters">Chapters</Link>
                    </Menu.Item>
                    <Menu.Item key="4" icon={<FileOutlined />}>
                        <Link to="/ChapterQuestions">Chapter Questions</Link>
                    </Menu.Item>
                    <Menu.Item key="5" icon={<FileOutlined />}>
                        <Link to="/AssesmentQuestions">Assesment Questions</Link>
                    </Menu.Item>
                    <Menu.Item key="6" icon={<QuestionCircleOutlined />}>
                        <Link to="/UsersQueries">Users Queries</Link>
                    </Menu.Item>
                    <Menu.Item key="7" icon={<LogoutOutlined />}>
                        <a href="../admin/login" >Logout</a>
                    </Menu.Item>

                </Menu>
            </Sider>
            <Layout className="site-layout" >
                <Header className="site-layout-background" style={{ padding: 0 }} >
                    <Title level={3} className="header-title">Hello {profile && profile.name}...!</Title>
                    <Avatar className="avatar-logo" size="large" style={{ backgroundColor: '#87d068', float: 'right', marginTop: "12px" }} icon={<UserOutlined />} />
                    <div className="logo glg-logo" >  <a href="https://www.tycl.org.in/girlsleadgirls/#/user"><img src={logo} alt="" /></a></div>
                    {
                        menuCollapsed ?
                            <MenuOutlined onClick={() => {
                                toggleMenu()
                            }} className="mobileMenu" />
                            : <CloseOutlined className="mobileMenu" onClick={() => {
                                toggleMenu()
                            }} />
                    }
                    <Menu className={menuCollapsed ? "mobile-menu" : "mobile-menu expand"} theme="dark" defaultSelectedKeys={['1']} mode="inline">
                        <Menu.Item key="1" icon={<UserOutlined />}>
                            <Link to="/" onClick={() => {
                                toggleMenu()
                            }}>Users</Link>
                        </Menu.Item>

                        <Menu.Item key="2" icon={<PieChartOutlined />}>
                            <Link to="/Dashboard" onClick={() => {
                                toggleMenu()
                            }}>Dashboard</Link>
                        </Menu.Item>

                        <Menu.Item key="3" icon={<ReadOutlined />}>
                            <Link onClick={() => {
                                toggleMenu()
                            }} to="/Chapters">Chapters</Link>
                        </Menu.Item>

                        <Menu.Item key="4" icon={<FileOutlined />}>
                            <Link onClick={() => {
                                toggleMenu()
                            }} to="/ChapterQuestions">Chapter Questions</Link>
                        </Menu.Item>

                        <Menu.Item key="5" icon={<FileOutlined />}>
                            <Link onClick={() => {
                                toggleMenu()
                            }} to="/AssesmentQuestions">Assesment Questions</Link>
                        </Menu.Item>

                        <Menu.Item key="6" icon={<QuestionCircleOutlined />}>
                            <Link onClick={() => {
                                toggleMenu()
                            }} to="/UsersQueries">Users Queries</Link>
                        </Menu.Item>
                        <Menu.Item key="7" icon={<LogoutOutlined />}>
                            <Link onClick={() => {
                                toggleMenu()
                            }} to="/Logout">Logout</Link>
                        </Menu.Item>
                    </Menu>
                </Header>
                <Content style={{ margin: '0 16px' }}>
                    <Title level={4} style={{ marginLeft: "1px", marginBottom: "20px" }} className="mobile-header-title">Hello  {profile && profile.name}...!</Title>
                    {children}
                </Content>
                <Footer style={{ textAlign: 'center' }}>GirlsLeadGirls ©2020, Created by TYCL</Footer>
            </Layout>
        </Layout>
    )
}

export default AdminLayout